import { createAction } from "redux-actions";
import * as NotiActions from "./NotificationActions";
import * as M from "../models";
import { Thunk } from "./Thunk";
import { Api } from "../services/Api";

const prefix = "COUNTRY_";

/** flag that makes sure init is only called once */
let loading = false;

export class Constants {
    public static INITIALIZED = prefix + "INITIALIZED";
    public static LOADING = prefix + "LOADING";
    public static RECEIVED = prefix + "RECEIVED";
}

export interface AllDataReceivedPayload {
    countries: M.Country.Country[];
}

export const init = (): Thunk => async (dispatch, getState) => {
    const { countries } = getState().countries;

    // not connected to api
    if (!getState().conn.connected) {
        return;
    }

    if (countries.size <= 0 && getState().auth.authenticated) {
        if (loading)
            return;

        loading = true;

        dispatch(onLoading(true));

        const api = new Api(getState());
        const result = await api.get<M.Country.Country[]>(Api.endpoints.country.list);

        if (result.isSuccess && result.data) {
            dispatch(onAllReceived(result.data));
            dispatch(onInitialized(true));
        }
        else {
            dispatch(NotiActions.notifyError(M.Result.Result.errorsOrMessage(result).join("<br />")));
            dispatch(onAllReceived([]));
        }

        loading = false;
    }

    dispatch(onLoading(false));
};

export const onInitialized = createAction<boolean, boolean>(
    Constants.INITIALIZED, (isInitialized) => (isInitialized),
);

export const onLoading = createAction<boolean, boolean>(
    Constants.LOADING, (isLoading) => (isLoading),
);

export const onAllReceived = createAction<AllDataReceivedPayload, M.Country.Country[]>(
    Constants.RECEIVED, (countries) => ({ countries }),
);



// WEBPACK FOOTER //
// ./src/actions/CountryActions.ts